import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API } from "aws-amplify";
import { infoCards } from "../Utils/constants";
import { ToastContainer } from "react-toastify";

import {
  getConfigProduct,
  getConfigProductIG,
  getConfigProductRG,
  getConfigProductUC,
} from "../Store/secureInvestmentIncome/actions";
import { validateAdviserRegister } from "../Store/adviser/actions";
import CardTypeService from "../Components/cardsTypeService";
import ModaFormVAS from "../Components/modalFormVAS";
import ModalFormIG from "../Components/modalFormIG";
import { ModalFormRV } from "../Components/modalFormRV";
import ModalFormRG from "../Components/modalFormRG";
import ModalFormRVO from "../Components/modalFormRVO";
import ModalSISCO from '../Components/modalSISCO';
import ModalRegisterAdviser from "../Components/modalRegisterAdviser";
import TitleSecureInves from "../Components/titleSeccureInsvesment";

import Loading from "../Components/loading";
import ModalFormUC from "../Components/modalFormUC";
import Footer from "../Components/Footer";
import SpinnerTable from "../Components/SpinnerTable";

import { v4 as uuidv4 } from 'uuid';
import { getConfigIG, getConfigUC } from "../Store/config/actions";
import { addProductosFlagCancelar } from "../Store/config/actions";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { usersRVEO } from "../Utils/userRVEO";
import { productCardListDictionary } from "../../src/Utils/constants.js";

const SecureInvestmentIncome = () => {
  const { channel, idClient: emailUser } = useSelector((state) => ({
    channel: state.login.channel,
    idClient: decryptEstandar(state.login.idClient),
  }));
  const [showRG, setshowRG] = useState(false);
  const [showRV, setShowRV] = useState(false);
  const [showRI, setshowRI] = useState(false);
  const [showVAS, setshowVAS] = useState(false);
  const [showIG, setshowIG] = useState(false);
  const [showUC, setshowUC] = useState(false);
  const [showRVO, setshowRVO] = useState(false);
  const showSISCO = useSelector((state) => state.cotizador.showSISCO_STATE);
  const [idProduct, setIdProduct] = useState(null);
  const [idProspecto, setIdProspecto] = useState("");
  const [investmentProfile, setInvestmentProfile] = useState("");
  const [investmentPortfolio, setInvestmentPortfolio] = useState("");
  const [portafoliosIG, setPortafoliosIG ] = useState([]);
  const [portafoliosUC, setPortafoliosUC] = useState([]);
  const [loadingView, setLoading] = useState(false);
  const [loadProducts, setLoadProducts] = useState(false);
  const [dataProducts, setDataProducts] = useState([]);
  const [productosFlagCancelar, setProductosFlagCancelar] = useState();
  const [uuid, setUuid] = useState("");
  const generateID = uuidv4();
  const ideTransaccion = generateID;

  const recommended = useSelector((state) => state.recommended);
  const hasValidClientToken = useSelector((state) => state.data.hasValidClientToken || false);
  const store = useSelector((state) => {
    const { repLegal, ...filteredStore } = state.data;
    return filteredStore;
  });
  const assured = Object.values(store)[0];
  const contratant = Object.values(store)[1];
  const callApi = useSelector((state) => state.adviser.callApi);
  const loading = useSelector((state) => state.adviser.loading);
  const error_permit = useSelector((state) => state.adviser.error_permit);
  const dispatch = useDispatch();
  const prospecto = useSelector((state) => state.prospect.idProspecto);

  const params = new URLSearchParams(window.location.search);
  const availableProducts = useSelector((state) => state.login.access_configuration.availableProducts);
  const capabilities = useSelector((state) => (state.login.access_configuration && state.login.access_configuration.capabilities));
  const { bypassAuthRV = false } = useSelector((state) => state.login.access_configuration);

  useEffect(() => {
    if (
      recommended &&
      recommended.recommended &&
      recommended.recommended.investmentProfile &&
      recommended.recommended.portafolios
    ) {
      setInvestmentProfile(recommended.recommended.investmentProfile);
      setInvestmentPortfolio(recommended.recommended.portafolios);
    }
  }, [recommended]);

  const getPortafolios = async (id_product) => {
    setLoading(true);
    try {
      const response = await API.get("api-rentas", "/producto/configmin/IG");

      if (response) {
        setPortafoliosIG(response);
      }

      setshowIG(true);
      setIdProduct(id_product);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getPortafoliosUC = async (id_product) => {
    setLoading(true);
    try {
      const response = await API.get("api-rentas", "/producto/configmin/UC");

      if (response) {
        setPortafoliosUC(response);
      }

      setshowUC(true);
      setIdProduct(id_product);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getConfigProduct());
    dispatch(getConfigProductIG());
    dispatch(getConfigProductUC());
    dispatch(getConfigProductRG());
    if (callApi) validateAdviserRegister(dispatch);
    if (prospecto) {
      setIdProspecto(prospecto);
    }
    if (
      assured != undefined &&
      contratant != undefined &&
      Object.keys(contratant).length > 0 &&
      Object.keys(assured).length > 0 &&
      Object.values(assured)[1] != Object.values(contratant)[1]
    ) {
      infoCards.forEach((item) => {
        if (item.id === 0) {
          item.status = 0;
        }
      });
    } else {
      infoCards.forEach((item) => {
        if (item.id === 0) {
          item.status = 1;
        }
      });
    }
  }, [prospecto, assured, contratant]);

  let onCloseModal = (id_product) => {
    switch (id_product) {
      case 0:
        setshowVAS(false);
        break;
      case 1:
        setshowRG(false);
        break;
      case 2:
        setshowRI(false);
        break;
      case 3:
        setshowIG(false);
        break;
      case 4:
        setshowUC(false);
        break;
      case 5:
        setShowRV(false);
        break;
      case 6:
        setshowRVO(false);
        break;
    }
  };

  let openModal = (id_product) => {
    switch (id_product) {
      case 0:
        setshowVAS(true);
        setIdProduct(id_product);
        break;
      case 1:
        setshowRG(true);
        setIdProduct(id_product);
        break;
      case 2:
        setshowRI(true);
        setIdProduct(id_product);
        break;
      case 3:
        getPortafolios(id_product);
        break;
      case 4:
        setshowUC(true);
        getPortafoliosUC(id_product);
        break;
      case 5:
        setShowRV(true);
        break;
      case 6:
        setshowRVO(true);
        setIdProduct(id_product);
        break;
    }
  };

  const handleApiProducts = async () => {
    try {
      setLoadProducts(true);
      const response = await API.post("api-rentas", "/lista-productos", {
        body: {},
      });

      const { status } = response;
      if (status) {
        let filtering = response.data.filter((el) => !el.disabled);
        
        // Se filtran los productos disponibles según la lista de productos permitidos para el usuario
        let listProducts = filtering.filter(product => availableProducts.includes(productCardListDictionary[product.name]));

        // bypassAuthRV sin sesión válida de Salesforce solo habilita cotizar Renta Vitalicia Extra oficial
       if (!hasValidClientToken && bypassAuthRV) {
          listProducts = listProducts.map(product => {
            return {
              ...product,
              disabledToUser: product.name !== "rentaVitalicia"
            };
          });
        }

        // Si el usuario no tiene permiso para ver Renta Vitalicia Oficial, se elimina el card de la lista de productos
        if (listProducts.some(product => product.name === "rentaVitaliciaOficiales") && capabilities.canViewRVOfficial === false) {
          listProducts = listProducts.filter(product => product.name !== "rentaVitaliciaOficiales");
        }

        filtering = filtering.map((item) => {
          if (channel === "admin") return item;

          if (!hasValidClientToken && usersRVEO.some((user) => user.email === emailUser)) {
            return { ...item, disabledToUser: item.name !== "rentaVitalicia" };
          }
          return item;
        })

        setLoadProducts(false);
        setDataProducts(listProducts);
        if (response.productosFlagCancelar && Array.isArray(response.productosFlagCancelar)) {
          setProductosFlagCancelar(response.productosFlagCancelar);
          dispatch(addProductosFlagCancelar(response.productosFlagCancelar));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleApiProducts();
  }, []);

  useEffect(() => {
    if (showRG) {
      setUuid(ideTransaccion);
    }
  }, [showRG]);

  useEffect(() => { console.log(showSISCO) }, [showSISCO])



  return (
    <>
      <div className="wrap">
        <div className="content-box">
          <div className="secureInvestmentIncome">
            <TitleSecureInves
              dataState={store}
              investmentProfile={investmentProfile}
            />
            <div className="contentcard">
              {loadProducts ? (
                <SpinnerTable
                  title="¡Danos un momento!"
                  subtitle="Se está cargando la información."
                />
              ) : (
                dataProducts.length > 1 &&
                dataProducts.map((item, key) => {
                  return (
                    item.status === 1 && (
                      <CardTypeService
                        item={item}
                        key={key}
                        openModal={openModal}
                      />
                  ))
                })
              )}
            </div>
          </div>
        </div>
        <ModaFormVAS
          dataState={store}
          close={onCloseModal}
          open={showVAS}
          id_product={idProduct}
          idProspecto={idProspecto}
          investmentProfile={investmentProfile}
        />
        <ModalFormRG
          dataState={store}
          close={onCloseModal}
          open={showRG}
          id_product={idProduct}
          idProspecto={idProspecto}
          investmentProfile={investmentProfile}
          uuid={uuid}
        />
        <ModalFormRV
          open={showRV}
          close={() => setShowRV(false)}
          investmentProfile={investmentProfile}
          investmentPortfolio={investmentPortfolio}
          dataState={store}
        />
        <ModalFormIG
          dataState={store}
          close={onCloseModal}
          open={showIG}
          id_product={idProduct}
          idProspecto={idProspecto}
          investmentProfile={investmentProfile}
          investmentPortfolio={investmentPortfolio}
          portafolios={portafoliosIG}
          uuid={uuid}
        />
        <ModalFormUC
          dataState={store}
          close={onCloseModal}
          open={showUC}
          id_product={idProduct}
          idProspecto={idProspecto}
          investmentProfile={investmentProfile}
          investmentPortfolio={investmentPortfolio}
          portafolios={portafoliosUC}
          uuid={uuid}
        />
        <ModalFormRVO
          open={showRVO}
          close={onCloseModal}
          id_product={idProduct}
        />
        {/* {showSISCO && <ModalSISCO open={showSISCO} />} */}
        <ModalRegisterAdviser open={error_permit} login={true} />
        <ToastContainer containerId={"A"} />
        {loading && <Loading />}
        {loadingView && <Loading loading={loadingView} />}
      </div>
      <Footer />
    </>
  );
};

export default SecureInvestmentIncome;
